import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ShareButton = ({ sessionUrl, sessionTitle }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard?.writeText(sessionUrl);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
        setShowShareMenu(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const handleShareKakao = () => {
    const kakaoMessage = `${sessionTitle}\n\n참가신청:\n${sessionUrl}`;
    console.log('Sharing to KakaoTalk:', kakaoMessage);
    setShowShareMenu(false);
  };

  const handleShareNative = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: sessionTitle,
          text: `${sessionTitle} 세션에 참가하세요!`,
          url: sessionUrl
        });
        setShowShareMenu(false);
      } catch (err) {
        console.error('Error sharing:', err);
      }
    }
  };

  return (
    <div className="relative">
      <Button
        variant="outline"
        iconName="Share2"
        iconPosition="left"
        onClick={() => setShowShareMenu(!showShareMenu)}
        fullWidth
      >
        세션 공유하기
      </Button>

      {showShareMenu && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setShowShareMenu(false)}
          />
          <div className="
            absolute bottom-full left-0 right-0 mb-2 z-50
            bg-popover border border-border rounded-lg shadow-lg
            overflow-hidden
          ">
            <button
              onClick={handleCopyLink}
              className="
                w-full flex items-center gap-3 px-4 py-3
                hover:bg-muted transition-athletic
                text-left
              "
            >
              <Icon name={isCopied ? 'Check' : 'Link'} size={20} color={isCopied ? 'var(--color-success)' : 'var(--color-foreground)'} />
              <div className="flex-1">
                <p className={`text-sm font-medium ${isCopied ? 'text-success' : 'text-foreground'}`}>
                  {isCopied ? '링크가 복사되었습니다!' : '링크 복사'}
                </p>
                {!isCopied && (
                  <p className="text-xs caption text-muted-foreground">
                    URL을 클립보드에 복사
                  </p>
                )}
              </div>
            </button>

            <button
              onClick={handleShareKakao}
              className="
                w-full flex items-center gap-3 px-4 py-3
                hover:bg-muted transition-athletic
                text-left border-t border-border
              "
            >
              <Icon name="MessageCircle" size={20} color="var(--color-accent)" />
              <div className="flex-1">
                <p className="text-sm font-medium text-foreground">
                  카카오톡 공유
                </p>
                <p className="text-xs caption text-muted-foreground">
                  카카오톡으로 세션 공유
                </p>
              </div>
            </button>

            {navigator.share && (
              <button
                onClick={handleShareNative}
                className="
                  w-full flex items-center gap-3 px-4 py-3
                  hover:bg-muted transition-athletic
                  text-left border-t border-border
                "
              >
                <Icon name="Share" size={20} color="var(--color-foreground)" />
                <div className="flex-1">
                  <p className="text-sm font-medium text-foreground">
                    다른 방법으로 공유
                  </p>
                  <p className="text-xs caption text-muted-foreground">
                    시스템 공유 메뉴 열기
                  </p>
                </div>
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default ShareButton;